<template>
  <a-tooltip>
    <template #title v-if="showTooltip">
      Esta acción está deshabilitada porque no tiene un identificador de este canal vinculado a esta secuencia. 
      <a @click="toSectionIdentifier">Agregar identificador</a>
    </template>
    <div class="new-message" :class="{ disabled: disabled }" @click="handleClick">
      <component :is="IconByType[type]" class="new-message__icon" />

      <p class="new-message__description">{{ text }}</p>
    </div>
  </a-tooltip>
</template>

<script setup lang="ts">
import { SequenceNodeType } from "@/@types/flows/sequences";
import { IconByType } from "@/app/flows/sequences/utils/icons";
import { inject, Ref } from "vue";
import { TemplateTabsKey } from "@/@types/flows/sequences/components";

const props = defineProps<{ type: SequenceNodeType; text: string; disabled: boolean; showTooltip: boolean; }>();

const currentTab = inject('currentTab') as Ref<boolean>;

const emit = defineEmits<{
  click: [nodeType: SequenceNodeType];
}>();

const handleClick = () => {
  if (!props.disabled) emit("click", props.type);
};

const toSectionIdentifier = () => {
  console.log(currentTab.value);
  currentTab.value = TemplateTabsKey.Identifiers;
};
</script>

<style scoped lang="sass">
.new-message
  height: 126px
  background: #FFF
  border-radius: 4px
  border: 1px dashed $primary
  cursor: pointer
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  gap: 10px

  &__description
    font-size: 14px
    text-align: center
    color: $primary
    margin: 0
    padding: 0 60px

  &.disabled
    filter: grayscale(1)
    opacity: 0.6
    cursor: not-allowed

:deep(.new-message__icon)
  display: block
  color: $primary
  font-size: 20px
</style>
